export const PORTARIA_SEGURANCA = 'PORTARIA_SEGURANCA';
export const ALIMENTACAO = 'ALIMENTACAO';
export const GESTAO_FIGURACAO = 'GESTAO_FIGURACAO';
export const ANALISTA = 'ANALISTA';
export const ASSISTENTE_DIRECAO = 'ASSISTENTE_DIRECAO';
export const FIGURINO_CARACTERIZACAO = 'FIGURINO_CARACTERIZACAO';
export const PRODUTOR_GLOBO = 'PRODUTOR_GLOBO';
export const BASE_PRODUCAO = 'BASE_PRODUCAO';
export const FIGURANTE = 'FIGURANTE';
export const TIME_COMFIGURA = 'TIME_COMFIGURA';
export const SUPORTE = 'SUPORTE';
export const SEGUROS = 'SEGUROS';
export const TRANSPORTE = 'TRANSPORTE';

export const SOCIO_AGENCIA = 'SOCIO_AGENCIA';
export const PRODUTOR_AGENCIA = 'PRODUTOR_AGENCIA';
export const FISCAL_AGENCIA = 'FISCAL_AGENCIA';
export const PRODUTOR_EXECUTIVO = 'PRODUTOR_EXECUTIVO';
export const SEGURANCA_EMPRESARIAL = 'SEGURANCA_EMPRESARIAL';
export const FISCAL_AGENCIA_01835710000102 = 'FISCAL_AGENCIA_01835710000102';
export const FISCAL_SECURITY = 'FISCAL_AGENCIA_10692415000127';
